/* projects/speaker-platform/src/app/molecules/weekly-planning-preview/weekly-planning-preview.component.scss */
.weeklyplanningpreview {
  display: flex;
  justify-content: space-between;
}
/*# sourceMappingURL=weekly-planning-preview.component-IZELSWOQ.css.map */
